import { TimeSpentQuery_timeSpentList, UserFilter, UserRole } from '~/graphql';

export type ITimeSpent = TimeSpentQuery_timeSpentList;

export const userFilter: UserFilter = {
    roles: [UserRole.EXCAVATOR_OPERATOR],
};
